export default __webpack_public_path__ + "static/media/kar.e733b3c9.jpg";